import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Yükleniyor…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
